export interface User {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    extension_Company: string;
    isAnonymous: boolean;
}

export interface DecodedUser {
  emails: string[];
  extension_Company: string;
  family_name: string;
  given_name: string;
}

export enum UserFieldId {
  email = '7f685ebb-7c54-4cff-a1bc-772562d25c38',
  firstName = '3f746946-34b4-442c-a677-e232cdd2bc40',
  lastName = 'e1dfc514-f301-4cb2-855a-4c8fa8331207',
  extension_Company = '2c4da980-2c7f-ea11-a811-000d3a2d0171'
}
